import React, { useEffect } from "react";
import icClosePopup from "../assests/images/close_popup.svg";
import { createPortal } from 'react-dom';

function MainPageDialog({
  title,
  component,
  children,
  footer = true,
  maxHeight = false,
  contentCls = 'p-2',
  footerList = [],
  onCancelHandler,
  modalSize = 'large', // Large and small popup screen size
  hideOverFlow,
  customHeight,
}) {
  //for removing whole page scroll on opening modal component
  useEffect(() => {
    document.body.style.overflow = 'hidden';
    return () => {
      document.body.style.overflow = 'auto';
    }
  }, [])

  return createPortal(
    <>
      <div className="justify-center items-center flex overflow-x-hidden overflow-y-auto fixed inset-0 z-[80] outline-none focus:outline-none">
        <div className={`relative ${modalSize == 'small' ? 'w-[600px]' : modalSize == "md" ? "w-[850px]" : '2xl:container1440 xl:container1440 lg:container1024 md:container1024 sm:container1024'} m-auto`}>
          {/*content*/}
          <div className={`border border-slate-300 rounded shadow-md ${maxHeight ? 'sm-max-popup-height' : "custom-popup-height"} ${customHeight ? customHeight : ""} relative flex flex-col w-full bg-white outline-none`}>
            {/*header*/}
            {title && <div className="border-b border-gray-200 rounded-b dark:border-gray-600 flex rounded-tl z-10 rounded-tr items-center justify-between p-2 popup-header-shadow bg-gray-f8">
              <h3 className="text-lg text-black-300 font-medium flex gap-2 items-center">
                {title}
              </h3>
              <div className="pr-2">
                <a className="cursor-pointer border border-gray-89 hover:bg-gray-ec rounded-lg p-2 flex" onClick={onCancelHandler}>
                 <img src={icClosePopup} className="w-[14px]" />
                </a>
              </div>

            </div>}
            {/*body*/}
            {children ? (
              <>
                <PageDialogContent hideOverFlow={hideOverFlow} contentCls={contentCls}>
                  {children}
                </PageDialogContent>
                {/*footer*/}
                {footer && <PageDialogFooter footerList={footerList} />}
              </>
            ) : (
              <>
                {component ? component : ''}

              </>
            )}
          </div>
        </div>
      </div>
      <div className="opacity-60 fixed inset-0 z-[70] bg-black"></div>
    </>,
    document.getElementById("portal")
  );
}
export const PageDialogContent = ({ children, contentScroll = true, contentCls = 'p-2',hideOverFlow }) => {
  return (
    <>
      <div className={`relative px-6 text-sm flex-1 popup-body-h ${contentScroll && !hideOverFlow ? "overflow-auto" : ""} ${contentCls}`}>
        {children}
      </div>
    </>
  )
}

export const PageDialogFooter = ({ children, footerList, customClasses }) => {
  // this component `PageDialogFooter` is also being used individually in other components (i.e. pages/behaviouralHealth/goal.js)
  const returnButton = (item, itemKey) => {
    if (item?.type == 'save' || item?.type == 'add' || item?.type == 'create' || item?.type == 'update') {
      return <button
        key={'button_' + item?.type + '_' + itemKey}
        className={`py-1 px-2.5 font-normal border bg-blue-500 text-white`}
        type="button"
        disabled={item?.disabled ? item?.disabled : item?.loading ? item.loading : false}
        onClick={item?.action}
      >
        {item?.loading ?
          item?.type == 'update' && 'Updating...' || item?.type == 'save' && 'Saving...' || item?.type == 'add' && 'Adding...' || item?.type == 'create' && 'Creating...'
          :
          item?.title
        }
      </button>
    } else if (item?.type == 'edit') {
      return <button
        key={'button_' + item?.type + '_' + itemKey}
        className={`py-1 px-2.5 font-normal rounded border border-bgGreen text-[14px] text-bgGreen hover:bg-bgGreen hover:text-white ${item?.loading ? 'cursor-not-allowed' : 'cursor-pointer'}`}
        type="button"
        onClick={item?.action}
      >
        {item?.loading ?
          item?.type == 'edit' && 'Editing...'
          :
          item?.title
        }
      </button>
    } else if (item?.type == 'delete' || item?.type == 'remove') {
      return <button
        key={'button_' + item?.type + '_' + itemKey}
        className={`py-1 px-2.5 font-normal rounded text-[14px] text-danger-hover border-danger-hover border  hover:bg-danger-hover hover:text-white ${item?.loading ? 'cursor-not-allowed' : 'cursor-pointer'}`}
        type="button"
        disabled={item?.disabled}
        onClick={item?.action}
      >
        {item?.loading ?
          item?.type == 'delete' && 'Deleting...' || item?.type == 'remove' && 'Removing...'
          :
          item?.title
        }
      </button>
    } else if (item?.type == 'cancel' || item?.type == 'close') {
      return <button
        key={'button_' + item?.type + '_' + itemKey}
        className="py-1 px-2.5 font-normal rounded text-[14px] text-black-300 border-gray-c3 border  hover:bg-gray-e5 hover:text-black-300"
        type="button"
        disabled={item?.disabled}
        onClick={item?.action}
      >
        {item?.title}
      </button>
    }
  }
  return (
    <>
      <div className={`flex items-center gap-2 border-t border-gray-200 rounded-b dark:border-gray-600 rounded-bl rounded-br justify-start bg-gray-f8 popup-footer-shadow p-2 ${customClasses}`}>
        {children ? children : ''}
        {footerList && footerList.map((item, itemKey) => returnButton(item, itemKey))}

      </div>
    </>
  )
}
export default MainPageDialog;